import React from 'react';
import {
  Button,
  Box,
  Typography,
} from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';

const FileUpload = ({ onFileSelect, selectedFile, accept = '.csv', id = 'file-upload-button' }) => {
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      onFileSelect(file);
    }
  };

  return (
    <Box>
      <input
        accept={accept}
        style={{ display: 'none' }}
        id={id}
        type="file"
        onChange={handleFileChange}
      />
      <label htmlFor={id}>
        <Button
          variant="outlined"
          component="span"
          startIcon={<UploadFileIcon />}
          fullWidth
        >
          Choose File
        </Button>
      </label>

      {selectedFile && (
        <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary' }}>
          Selected: {selectedFile.name}
        </Typography>
      )}
    </Box>
  );
};

export default FileUpload;
